import { IContentType } from '~src/spacesPlatform/models/ContentTypes';
import { OrderKeys } from '~src/spacesPlatform/models/OrderKeys';
import { Order } from '~src/spacesPlatform/models/sort/Order';

// This is currently only used for the defaultOrder from what I can tell
export const ConnectedApplicationContentType: IContentType = {
  name: 'connectedApplication',
  filterKeys: [],
  canShowFilterPanel: false,
  orderKeys: [
    OrderKeys.name
  ],
  defaultOrder: [Order.asc(OrderKeys.name)]
};
